module.exports = __webpack_public_path__ + "img/arr-left.3b282807.svg";